import BaseService from '../../base/base_service';
import DateFormatter from '../../utils/date_formatter';

export default class TimeService extends BaseService {

    static CLASS = 'TimeService';

    now() {
        return Date.now();
    }

    getCurrentDate() {
        return new Date();
    }

    formatUtc(date) {
        return DateFormatter.formatUtc(date);
    }

    findDifferenceBetweenDatesInDays(firstDate: Date, secondDate: Date) {
        return this._findDifferenceBetweenDates(firstDate, secondDate, 'days');
    }

    findDifferenceBetweenDatesInHours(firstDate: Date, secondDate: Date) {
        return this._findDifferenceBetweenDates(firstDate, secondDate, 'hours');
    }

    findDifferenceBetweenDatesInMinutes(firstDate: Date, secondDate: Date) {
        return this._findDifferenceBetweenDates(firstDate, secondDate, 'minutes');
    }

    findDifferenceBetweenDatesInSeconds(firstDate: Date, secondDate: Date) {
        return this._findDifferenceBetweenDates(firstDate, secondDate, 'seconds');
    }

    private _findDifferenceBetweenDates(firstDate: Date, secondDate: Date, differenceType: string) {
        // seconds = milliseconds/1000
        // minutes = seconds/60
        // hours = minutes/60
        // Days = hours/24
        let divideBy;
        switch (differenceType && differenceType.toLowerCase()) {
            case 'days':
                divideBy = 1000 * 60 * 60 * 24;
                break;
            case 'hours':
                divideBy = 1000 * 60 * 60;
                break;
            case 'minutes':
                divideBy = 1000 * 60;
                break;
            case 'seconds':
            default:
                divideBy = 1000;
                break;
        }

        return Math.floor((Number(firstDate) - Number(secondDate)) / divideBy);
    }

    parseDate(dateAsString: string) {
        return new Date(dateAsString);
    }
}